import { defineComponent as u, computed as e, createElementBlock as s, openBlock as a, normalizeClass as n, createElementVNode as v, Fragment as g, renderList as f, renderSlot as w } from "vue";
import "@ds/components/Document";
import { tw as r } from "../../utils/tailwind.js";
const k = /* @__PURE__ */ u({
  __name: "DocumentList",
  props: {
    documents: {},
    variant: { default: "grid" }
  },
  setup(i) {
    const t = i, m = e(() => [
      r`gap-16`,
      t.variant === "grid" && r`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2`,
      t.variant === "inline" && r`flex`
    ]), c = e(() => [
      // By spec, they have a fixed width only in the inline variant
      t.variant === "inline" && r`w-full min-w-240 max-w-448`
    ]), d = e(() => [
      // By spec, they have a fixed width only in the inline variant
      t.variant === "inline" && r`-mx-24 -mb-24 -mt-16 snap-x snap-mandatory scroll-pl-24 overflow-x-auto overscroll-x-contain scroll-smooth p-24 transition-transform duration-700 scrollbar-none`,
      t.variant === "grid" && r`mt-8`
    ]);
    return (l, x) => (a(), s("div", {
      class: n(d.value)
    }, [
      v("ul", {
        class: n(m.value)
      }, [
        (a(!0), s(g, null, f(l.documents, (p, o) => (a(), s("li", {
          key: o,
          class: n(c.value)
        }, [
          w(l.$slots, "item", {
            document: p,
            index: o
          })
        ], 2))), 128))
      ], 2)
    ], 2));
  }
});
export {
  k as default
};
